import React, { FC, useCallback } from 'react';
import styles from './index.module.scss';
import { OrgsSelect } from 'src/shared';
import { getBuyerLink } from 'src/models/organisations/helpers';
import { useNavigate } from 'react-router-dom';

export const BuyersSearch: FC = () => {
  const navigate = useNavigate();

  const onSelect = useCallback(
    (orgId: string) => {
      navigate(getBuyerLink(orgId));
    },
    [navigate]
  );

  return <OrgsSelect onSelect={onSelect} className={styles.select} />;
};

export default BuyersSearch;
